export interface AdminTicketUser {
    id: number;
    name: string;
    surname: string;
    email: string;
    mobile: string | null;
    telegram_username: string | null;
    country: string | null;
}

export interface AdminTicketItem {
    id: number;
    user_id: number;
    user: AdminTicketUser | null;
    time: number;
    created_at: string;
    is_gift: boolean;
}

export interface AdminTicketsParams {
    per_page?: number;
    page?: number;
    sort_by?: "alny_tickets_auto_id" | "alny_tickets_auto_user_id" | "alny_tickets_auto_time" | "is_gift";
    sort_order?: "asc" | "desc";
    user_id?: number;
    is_gift?: boolean;
    date_from?: string;
    date_to?: string;
}

export interface PaginatedMeta {
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
    from: number | null;
    to: number | null;
}

export interface AdminTicketsResponse {
    success: boolean;
    data: AdminTicketItem[];
    meta: PaginatedMeta;
}

export interface AdminTicketsStatsResponse {
    success: boolean;
    data: {
        limit: number;
        remaining: number;
        purchased_count: number;
        gift_count: number;
    };
}

export interface AdminAwardTicketsPayload {
    user_id: number;
    is_gift: boolean;
    quantity: number;
}

export interface AdminAwardTicketsResponse {
    success: boolean;
    message: string;
    data?: {
        user_id: number;
        is_gift: boolean;
        quantity: number;
        ticket_ids: number[];
    };
}

export const ticketsEndpoints = {
    getAdminTicketsStats: {
        query: () => "/admin/tickets/stats",
    },
    getAdminTickets: {
        query: (params?: AdminTicketsParams) => {
            const queryParams = new URLSearchParams();
            if (params?.per_page) queryParams.append("per_page", params.per_page.toString());
            if (params?.page) queryParams.append("page", params.page.toString());
            if (params?.sort_by) queryParams.append("sort_by", params.sort_by);
            if (params?.sort_order) queryParams.append("sort_order", params.sort_order);
            if (params?.user_id) queryParams.append("user_id", params.user_id.toString());
            if (params?.is_gift !== undefined) queryParams.append("is_gift", params.is_gift.toString());
            if (params?.date_from) queryParams.append("date_from", params.date_from);
            if (params?.date_to) queryParams.append("date_to", params.date_to);
            const queryString = queryParams.toString();
            return `/admin/tickets${queryString ? `?${queryString}` : ""}`;
        },
    },
    awardTickets: {
        mutation: (payload: AdminAwardTicketsPayload) => ({
            url: "/admin/tickets/award",
            method: "POST" as const,
            body: payload,
        }),
    },
};

export const ticketsTags = ["Tickets"] as const;
